/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDRadiusDownLeftIcon24Regular = forwardRef('ArrowDRadiusDownLeftIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M20.125 5A8.125 8.125 0 0 1 12 13.125H4.633l5.106-5.106A.875.875 0 0 0 8.502 6.78l-5.327 5.327a2.675 2.675 0 0 0 0 3.784l5.327 5.327a.875.875 0 0 0 1.237-1.238l-5.106-5.106H12c5.454 0 9.875-4.421 9.875-9.875V4a.875.875 0 0 0-1.75 0v1Z" })));
});
